// Largo máximo de un mensaje de texto. Mismos números que el servidor (server/config/limitesChat.js), que es quien manda:
// aquí solo se evita escribir de más. Los de archivos están en adjuntos.js.
export const MAX_TEXTO_CHAT = 2000;
export const MAX_TEXTO_SOPORTE = 2000;
export const MAX_TEXTO_SOPORTE_ADMIN = 4000;
